<h2 mat-dialog-title class="unregister-title">Abmeldung bestätigen</h2>

<mat-dialog-content class="unregister-content">
  <p class="unregister-text">
    Du möchtest dich vom Event <strong>{{ data.eventName }}</strong> abmelden.
    Bitte gib einen Grund an:
  </p>
  <mat-form-field appearance="outline" class="unregister-input">
    <mat-label>Begründung</mat-label>
    <textarea
      matInput
      [(ngModel)]="excuseText"
      placeholder="Warum kannst du nicht teilnehmen?"
      rows="3"
      maxlength="500"
    ></textarea>
    <mat-hint align="end">{{ excuseText.length }} / 500</mat-hint>
  </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions align="end" class="unregister-actions">
  <button
    mat-raised-button
    color="warn"
    class="unregister-btn"
    [disabled]="!isValid()"
    (click)="onConfirm()">
    <mat-icon>event_busy</mat-icon>
    Abmelden
  </button>
  <button
    mat-stroked-button
    class="unregister-btn"
    (click)="onCancel()">
    Abbrechen
  </button>
</mat-dialog-actions>
